import { render, staticRenderFns } from "./SupportLayout.vue?vue&type=template&id=33a7b8e3&"
import script from "./SupportLayout.vue?vue&type=script&lang=js&"
export * from "./SupportLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports